import { useMutation } from '@apollo/client';
import { SORT_CATEGORIES_MUTATION } from '../mutations/SORT_CATEGORIES_MUTATION';

export default function useSortCategoriesMutation() {
    return useMutation( SORT_CATEGORIES_MUTATION );
}
